import { getHost } from "./getHost";

// Prefer the live `currentLanguage` zoid prop (host's vuex presenterLocale —
// updates whenever the user switches language) over `currentUser
// .presenterLanguage` (persisted profile setting, doesn't track runtime
// changes). Falls back to the profile setting so an older host that
// doesn't pass `currentLanguage` still works.
export function getHostLanguage(): string | null {
  const host = getHost();
  return host?.currentLanguage ?? host?.currentUser?.presenterLanguage ?? null;
}

export function useHostLanguage(): string | null {
  return getHostLanguage();
}
